import { NG_VALIDATORS, Validator, AbstractControl,  Validators } from "@angular/forms";
import { Directive, Input } from "@angular/core";


@Directive({
  selector: '[min]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MinValidator, multi: true }]
})
export class MinValidator implements Validator {
  @Input('min') number: number;

  validate(control: AbstractControl): { [key: string]: any } {
    return Validators.min(this.number)(control);
  }
}

